module.exports = __webpack_public_path__ + "static/british-woman-jailed-49b9d977ca79f815b3a93e304e0d2f5f.png";